import type { FaireProductEntity } from "../../entity_types/product";

export const p_zerrh8dqh8: FaireProductEntity = {
  token: "p_zerrh8dqh8",
  type: "product",
  name: "Veggie Strike Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/e680a04eec9ed8add5c2e8b3972dacda07e6d06372fb815b36e9d2c18683ba4a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/11994cfff243cf05a8be0004da887d0905862c30b9ba379c8d6f28c2bb4593ba.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png"
  ],
  priceDollars: 3,
  description: "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:39.504Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
